import { useSelector } from 'react-redux';
import useShortCode from './useShortCode';

function useTipDismissed(name) {
  const shortCode = useShortCode();
  const { dismissedTips } = useSelector(state => state.alertReducer);
  return !!dismissedTips.find(r => r.shortCode === shortCode && r.name === name);
}

export default useTipDismissed;
